import React from 'react'
import { Box, BoxProps } from '@mui/material'

interface IconBoxListProps extends BoxProps {
  icon: React.ReactNode
}

const LeftIconHList = (props: IconBoxListProps) => {
  const { icon, children } = props

  return (
    <Box sx={{ display: 'flex', gap: '0.5vw', color: 'primary.dark' }}>
      <Box>{icon}</Box>
      {children}
    </Box>
  )
}

export default LeftIconHList
